import React, { Component } from 'react';
import Input from '@components/Input';
import { APP_TYPES } from '@config';
import { setCustomWoodStrength, setWoodStrengthClass } from '@reducers/selectors/material/actions';
import materialTabService from '@services/requests/material-tab.service';
import { APP_TEXTS } from '@texts';
import { connect } from 'react-redux';

import './styles.scss';

class WoodStrengthClass extends Component {

  state = {
    options: []
  };

  componentDidMount() {
    this.fetchWoodStrengthOptions();
  }

  fetchWoodStrengthOptions = () => {
    materialTabService.getMaterialWoodConnection().then(res => {
      if (res) {
        this.setState({
          options: res
        });
      }
    }).catch(error => {
      console.error('Failed to fetch wood strength options:', error);
      this.setState({ loading: false });
    });
  };

  handleStrengthChange = (event) => {
    this.props.setWoodStrengthClass(event.target.value);
  };

  handleCustomStrengthChange = (value) => {
    this.props.setCustomWoodStrength(value);
  };

  render() {
    const { woodStrengthClass, customWoodStrength } = this.props.wood;
    const { options } = this.state;

    return (
      <div className="wood-strength list-type">
        <div className="wood-strength__label mb-2">
          {APP_TEXTS.WOOD_STRENGTH_CLASS_LABEL.Content}
        </div>
        <div className="wood-strength__controls d-flex align-items-center">
          <select
            value={woodStrengthClass}
            onChange={this.handleStrengthChange}
            className="form-control w-50 mr-2"
          >
            {options.map(option => (
              <option key={option.InternalName} value={option.InternalName}>
                {option.RunName}
              </option>
            ))}
          </select>

          {woodStrengthClass === "Custom" && (
            <div className="wood-strength__custom">
              <Input
                id="custom-strength"
                type="number"
                prefix="ρk ="
                postfix="kg/m³"
                value={customWoodStrength}
                onUpdate={this.handleCustomStrengthChange}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  wood: state.selectors.material[APP_TYPES.WOOD_CONNECTION].wood
});

export default connect(mapStateToProps, { setWoodStrengthClass, setCustomWoodStrength })(WoodStrengthClass); 



// WEBPACK FOOTER //
// ./src/views/Material/components/WoodMaterial/components/WoodStrengthClass.js